import React from "react";
import { useSelector } from "react-redux";
import { PasswordRestComp } from "../../components/password-reset/PasswordResetComp";
import { UpdatePassComp } from "../../components/password-reset/UpdatePassComp";
import "./passwordRestPage.css";

export const PasswordRestPage = () => {
	const { showUpdatePassForm } = useSelector(state => state.password);
	return (
		<div className="entry-page ">
			<div className="jumbotron form-box">
				{showUpdatePassForm ? <UpdatePassComp /> : <PasswordRestComp />}
			</div>
		</div>
	);
};
